var company = {};
module['exports'] = company;
company.suffix = require("./suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nep/company/index.js
 ** module id = 862
 ** module chunks = 0
 **/